import { render } from "./IconBase.vue?vue&type=template&id=6c416b18&scoped=true&ts=true"
import script from "./IconBase.vue?vue&type=script&lang=ts"
export * from "./IconBase.vue?vue&type=script&lang=ts"

import "./IconBase.vue?vue&type=style&index=0&id=6c416b18&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c416b18"]])

export default __exports__